<template>
    <div class="calendar_item" ref="calendarItem" @click="handlecalendarItem(itemdate.date)">
        <p>{{parseDate(itemdate.date,'{d}')}}</p>
        <p v-show="itemdate.isSelect" class="yuandian"></p>
    </div>
</template>
<script>
import { parseDate } from '@/utils'
export default {
    props:['itemdate'],
    created(){},
    methods:{
        parseDate,
        handlecalendarItem(date){
            this.$nextTick(()=>{
                this.$emit('setCalendarItem',date)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
// style=""
.calendar_item{
    text-align:center;
    padding: 8px;
    height: 100%;
}
.yuandian{
    margin:0 auto;
    height:8px;
    width:8px;
    border-radius:50%;
    background:#1d4434;
    margin-top:5px;
}
</style>